import fb, { getObjectFromCollection } from '@/firebase'
import store from '@/store'

const state = {
  lov: null
}

const getters = {
  lov: state => state.lov
}

const mutations = {
  setLov (state, payload) {
    state.lov = payload
  }
}

const actions = {
  getLov: ({commit}) => {
    store.dispatch('setLoaderStatus', true)
    fb.getLov()
      .then((fetched) => {
        if (!fetched.empty) {
          commit('setLov', getObjectFromCollection(fetched))
        }
        store.dispatch('setLoaderStatus', false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/lov.js